module.exports = __webpack_public_path__ + "img/boy.a3497d6b.png";